// removed by extract-text-webpack-plugin
module.exports = {"actions":"actions_dYKJK","divider":"divider_2kOzN","submit":"submit_1gp_f","hideRequirementMarker":"hideRequirementMarker_3MZl5","terms":"terms_2Dbd9"};


//////////////////
// WEBPACK FOOTER
// ./app/components/order/styles.scss
// module id = 485
// module chunks = 1